import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import CategoryScreen from '../../../components/categoryScreen';
import CategoryScreenBG from '../../../images/ComponentImages/categoryScreenBackground.png';
import CourseDescription from '../../../components/courseDescription';
import ItemGrid from '../../../components/itemGrid';
import WarningBlock from '../../../components/warningBlock';

export default function Page17({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<CategoryScreen titles={['Day 3']} BGImage={CategoryScreenBG} texts={['Stretch', 'Eat', 'Vision']} />
			<CourseDescription
				mt={true}
				title='Stretch Exercises'
				texts={[
					'Knee to Chest Stretch',
					'Pigeon Pose',
					'Cobra Pose',
					'Overhead Triceps and Shoulders Stretch',
					'Butterfly Fly Stretch',
					'Child’s Pose',
					'Stretching keeps the muscles flexible, strong, and healthy, and we need that flexibility to maintain a range of motion in the joints. Without it, the muscles shorten and become tight. Then, when you call on the muscles for activity, they are weak and unable to extend all the way.',
				]}
			/>
			<WarningBlock
				texts={[
					'Below is an example of a meal plan. Each Client varies. Each client’s body vaies. For custom food plans contact brugmethod@gmail.com to fit your needs. Thank you.',
				]}
				mt={true}
			/>
			<ItemGrid
				mt={true}
				title='Meal One (8:00-9:00)'
				rows={[['3- Whole Eggs', '2- Turkey Bacon', '½ cup- Rice']]}
			/>
			<ItemGrid
				mt={true}
				title='Meal Two (12:00)'
				rows={[['6oz- Ground Beef', '1 cup-Green Beans', '½ cup- Rice']]}
			/>
			<p className='mt-5 px-3'>Snack</p>
			<p className='mt-3 px-3'>Chocolate Rice Cakes</p>
			<ItemGrid
				mt={true}
				title='Meal Three (16:00-17:00)'
				rows={[['4-oz-Chicken Breast', '1 cup-Green Beans', '½ cup- Rice']]}
			/>
			<p className='mt-5 px-3'>
				Carbohydrates provide 4 calories per gram, protein provides 4 calories per gram, and fat provides 9
				calories per gram.
			</p>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
